import moment from 'moment';
import type Moment from 'moment';
import numeral from 'numeral';

import {deserializeDateRange} from 'nutshell-core/deserialize-date';
import {prettifyDateRange} from 'nutshell-core/utils';

import {QUOTA_NAME} from '../../report-types';
import type {DateRangeType} from '../../report-types';

import type {TooltipItem} from './tooltip-types';

export function formatNumber(value?: number | null) {
    const format = '0,0';

    return value ? numeral(value).format(format) : 0;
}

export function isItemQuota(item: TooltipItem) {
    return item.name === QUOTA_NAME;
}

export function isItemReference(item: TooltipItem) {
    return item.name.split('_')[0] === 'reference';
}

function parseDateFilters(
    filters: {
        [filtertype: string]: string;
    },
    dateRangeType: DateRangeType
):
    | {
          // @ts-expect-error
          startDate: Moment;
          // @ts-expect-error
          endDate: Moment;
      }
    | null
    | undefined {
    const reportString = filters[dateRangeType];

    if (!reportString || !reportString.includes(' TO ')) return null;

    // @ts-expect-error
    const dates = deserializeDateRange(filters[dateRangeType]);
    const startDate = moment.unix(dates.startDate);
    const endDate = moment.unix(dates.endDate);

    return {startDate, endDate};
}

/**
 * Given a filter object containing a time filter and a reportKey, return a friendly
 * date string.
 *
 * @param  {Object} filters       A filter object, containing a time range to use
 * @param  {string} dateRangeType The type of date range to get from filters
 * @return {string}               A nicely-formatted date string
 */
export function prettifyDateFilters(
    filters: {
        [filtertype: string]: string;
    },
    dateRangeType: DateRangeType
): string | null | undefined {
    const dates = parseDateFilters(filters, dateRangeType);

    if (dates) {
        return prettifyDateRange(dates.startDate, dates.endDate);
    }
}
